import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { VolunteerRecruit } from "@/components/app/volunteer-recruit";

const description =
  "Invite people you know to volunteer with T1D Warriors and see how your invites are doing.";

export const Route = createFileRoute("/_authenticated/recruit")({
  head: () => ({
    meta: [
      { title: "Recruit volunteers | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Recruit volunteers | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: RecruitRoute,
});

function RecruitRoute() {
  return (
    <AppShell eyebrow="Warrior Volunteer" title="Recruit volunteers">
      <VolunteerRecruit />
    </AppShell>
  );
}
